export const MODULOS_COM_ACOES_DE_PERFIL = [
  8,
  9,
  10,
  11,
  12,
  17,
  18,
  19,
  20,
  21,
];

export function possuiModuloComAcoesDePerfil(permissao) {
  const regras =
    permissao && Array.isArray(permissao.regras) ? permissao.regras : [];

  return regras.some((regra) =>
    MODULOS_COM_ACOES_DE_PERFIL.includes(Number(regra.moduloId))
  );
}
